import { Tooltip } from "@mui/material";

type CategoryTagProps = {
	value: {
		name: string;
		color: string;
	};
};
export const CategoryTag = ({
	value,
}: {
	value: CategoryTagProps["value"];
}) => {
	if (!value || !value.name || !value.color) {
		return null;
	}
	return (
		<Tooltip title={value.name} arrow>
			<div
				style={{
					backgroundColor: value.color,
					width: "26px",
					height: "26px",
					borderRadius: 4,
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					color: "#fff",
					fontWeight: "bold",
				}}
			>
				{value.name.charAt(0).toUpperCase()}
			</div>
		</Tooltip>
	);
};
